<template>
  <transition name="contact-sales-animation">
    <div
      v-show="contactSalesActive"
      class="fixed md:flex w-screen h-screen z-50 top-0 left-0 my-auto bg-[#0000009a] overflow-y-scroll overflow-hidden"
    >
      <transition name="contact-sales-animation-inner">
        <div
          class="md:w-[700px] md:h-[715px] bg-white rounded-xl shadow-xl md:mx-auto mx-[25px] md:my-auto mt-8 p-2 py-8 md:p-8"
        >
          <!-- heading -->
          <div
            class="contact-sales-inner flex items-center my-auto mx-auto w-full rounded-lg"
          >
            <h2
              class="text-[32px] pl-14 md:text-[32px] mx-auto font-semibold text-center"
              :class="{
                'text-[#292d34]': !isLoading['success'],
                'text-green-400': isLoading['success']
              }"
            >
              {{ isLoading['success'] ? 'Success!' : 'Contact Sales' }}
            </h2>
            <img
              @click="close"
              class="cursor-pointer mr-2 md:mr-0 md:w-[40px] md:h-[40px] w-[30px] h-[30px] fill-black block hover:rotate-180 hover:duration-500 hover:ease-in hover:transition duration-500"
              :src="$filters.media_path('/images/close-mail-grabber.svg')"
              alt="24/7 Online Course Building"
            />
          </div>
          <!-- form start -->
          <div class="py-10 md:p-10 p-2 mx-3">
            <Form
              v-if="!isLoading['success']"
              @submit="handleSubmit"
              :validation-schema="schema"
              v-slot="{ errors }"
              class="my-auto justify-between"
            >
              <!-- first name field -->
              <div class="sm:flex mx-auto justify-between mb-6">
                <label
                  for="firstName"
                  class="my-auto text-[#292D34] font-semibold after:ml-0.5 after:text-red-500 after:content-['*']"
                  >First Name</label
                >
                <div class="flex flex-col">
                  <Field
                    as="input"
                    type="text"
                    name="firstName"
                    id="firstName"
                    class="mt-1 inline-block h-10 max-w-[290px] lg:w-[290px] rounded-md border bg-white px-3 py-2 placeholder-slate-400 shadow-sm focus:border-[#2d8bff] focus:outline-none focus:ring-1 focus:ring-[#2d8bff] sm:text-sm"
                    :class="{
                      'border-red-500': errors.firstName,
                      'border-[#d1d1d160], border-slate-300': !errors.firstName
                    }"
                    v-model="firstName"
                  />
                  <ErrorMessage
                    name="firstName"
                    class="text-red-400 text-xs mt-2"
                  />
                </div>
              </div>
              <!-- last name field -->
              <div class="sm:flex mx-auto justify-between mb-6 w-full">
                <label
                  for="lastName"
                  class="my-auto text-[#292D34] font-semibold after:ml-0.5 after:text-red-500 after:content-['*']"
                  >Last Name</label
                >
                <div class="flex flex-col">
                  <Field
                    as="input"
                    type="text"
                    name="lastName"
                    id="lasttName"
                    class="mt-1 inline-block h-10 max-w-[290px] lg:w-[290px] rounded-md border bg-white px-3 py-2 placeholder-slate-400 shadow-sm focus:border-[#2d8bff] focus:outline-none focus:ring-1 focus:ring-[#2d8bff] sm:text-sm"
                    :class="{
                      'border-red-500': errors.lastName,
                      'border-[#d1d1d160], border-slate-300 ': !errors.lastName
                    }"
                    v-model="lastName"
                  />
                  <ErrorMessage
                    name="lastName"
                    class="text-red-400 text-xs mt-2"
                  />
                </div>
              </div>
              <!-- work email field -->
              <div class="sm:flex mx-auto justify-between mb-6 w-full">
                <label
                  for="email"
                  class="my-auto text-[#292D34] font-semibold after:ml-0.5 after:text-red-500 after:content-['*']"
                  >Work Email</label
                >
                <div class="flex flex-col">
                  <Field
                    as="input"
                    type="text"
                    name="email"
                    id="email"
                    class="mt-1 inline-block h-10 max-w-[290px] lg:w-[290px] rounded-md border bg-white px-3 py-2 placeholder-slate-400 shadow-sm focus:border-[#2d8bff] focus:outline-none focus:ring-1 focus:ring-[#2d8bff] sm:text-sm"
                    :class="{
                      'border-red-500': errors.email,
                      'border-[#d1d1d160], border-slate-300': !errors.email
                    }"
                    v-model="email"
                  />
                  <ErrorMessage
                    name="email"
                    class="text-red-400 text-xs mt-2"
                  />
                </div>
              </div>
              <!-- phone field -->
              <div class="sm:flex mx-auto justify-between mb-6 w-full">
                <label
                  for="phone"
                  class="my-auto text-[#292D34] font-semibold after:ml-0.5"
                  >Phone</label
                >
                <input
                  type="text"
                  name="phone"
                  id="phone"
                  class="mt-1 inline-block h-10 max-w-[290px] lg:w-[290px] rounded-md border border-[#d1d1d160] border-slate-300 bg-white px-3 py-2 placeholder-slate-400 shadow-sm focus:border-[#2d8bff] focus:outline-none focus:ring-1 focus:ring-[#2d8bff] sm:text-sm"
                  v-model="phone"
                />
              </div>
              <!-- company field -->
              <div class="sm:flex mx-auto justify-between mb-6">
                <label
                  for="company"
                  class="my-auto text-[#292D34] font-semibold after:ml-0.5"
                  >Company</label
                >
                <input
                  type="text"
                  name="company"
                  id="company"
                  class="mt-1 inline-block h-10 max-w-[290px] lg:w-[290px] rounded-md border border-[#d1d1d160] border-slate-300 bg-white px-3 py-2 placeholder-slate-400 shadow-sm focus:border-[#2d8bff] focus:outline-none focus:ring-1 focus:ring-[#2d8bff] sm:text-sm"
                  v-model="company"
                />
              </div>
              <!-- audience size field -->
              <div class="sm:flex mx-auto justify-between mb-6">
                <label
                  for="audienceSize"
                  class="my-auto text-[#292D34] font-semibold after:ml-0.5 after:text-red-500 after:content-['*']"
                  >Size of Current Audience</label
                >
                <div class="flex flex-col">
                  <Field
                    as="select"
                    id="audienceSize"
                    name="audienceSize"
                    class="form-select max-w-[290px] lg:w-[290px] mt-1 inline-block h-10 w-full rounded-md border border-[#d1d1d160] border-slate-300 bg-white px-3 py-2 placeholder-slate-400 shadow-sm focus:border-[#2d8bff] focus:outline-none focus:ring-1 focus:ring-[#2d8bff] sm:text-sm"
                    :class="{
                      'border-red-500': errors.audienceSize,
                      'border-[#d1d1d160]': !errors.audienceSize
                    }"
                    v-model="audienceSize"
                  >
                    <option value="0-500" selected>0-500</option>
                    <option value="500-10k">500-10k</option>
                    <option value="10k-100k">10k-100k</option>
                    <option value="100k - 1M">100k - 1M</option>
                    <option value="1 Million +">1 Million +</option>
                  </Field>
                  <ErrorMessage
                    name="audienceSize"
                    class="text-red-400 text-xs mt-2"
                  />
                </div>
              </div>
              <!-- backend error -->
              <div class="py-2" v-if="isLoading['error']">
                <p class="text-red-400 text-center">
                  There seem to be an issue, please try again later
                </p>
              </div>
              <!-- actions -->
              <div class="md:flex mt-10 w-full">
                <!-- confirm -->
                <p class="text-[#7c828d] pr-5 text-xs font-normal my-auto">
                  By submitting my information, I confirm that I have read and
                  understood the Platforma
                  <Link class="text-[#2d8bff]" href="/privacy"
                    >Privacy Policy.</Link
                  >
                </p>
                <!-- submit -->
                <button
                  type="submit"
                  class="mt-5 w-2/5 py-4 transition px-[35px] rounded-lg bg-[#2d8bff] min-[450px]:text-[15px] text-[14px] font-semibold text-white active:bg-[#054ca3] hover:scale-[102%] hover:ease-in hover:transition duration-1000 hover:delay-200 drop-shadow-[0px_10px_25px_#64A7F9]"
                  :disabled="isLoading['submit']"
                >
                  <LoaderComponent
                    :isReactive="isLoading['submit']"
                  ></LoaderComponent>
                  {{ isLoading['submit'] ? '' : 'Submit' }}
                </button>
              </div>
            </Form>
            <!-- success submit -->
            <div v-else>
              <h1 class="text-center">
                😃 Thank you for reaching out! <br />
                Our team will touch base with you asap!
              </h1>
              <div class="mt-20 text-center">
                <button
                  @click="close"
                  class="mt-5 w-1/3 py-4 transition px-[35px] mx-auto rounded-lg bg-green-400 text-[14px] font-semibold text-white active:bg-[#054ca3] hover:scale-[102%] hover:ease-in hover:transition duration-1000 hover:delay-200 drop-shadow-[0px_10px_25px_#64A7F9]"
                >
                  Close Form
                </button>
              </div>
            </div>
            <!-- success submit end -->
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { useReCaptcha } from 'vue-recaptcha-v3';
import Axios from 'axios';
import LoaderComponent from '../../../shareComponents/js/Components/LoaderComponent.vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';

const firstName = ref('');
const lastName = ref('');
const email = ref('');
const phone = ref('');
const company = ref('');
const audienceSize = ref('0-500');
const isLoading = reactive({});
const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

const schema = yup.object({
  firstName: yup.string().required('Please provide your first name'),
  lastName: yup.string().required('Please provide your last name'),
  email: yup.string().required('Please provide an email').email(),
  audienceSize: yup.string().required('Please provide your audience size')
});

const props = defineProps({
  contactSalesActive: {
    type: Boolean,
    required: false
  }
});

const emit = defineEmits(['close']);

const close = () => {
  emit('close');
};

const handleSubmit = async () => {
  isLoading['submit'] = true;

  await recaptchaLoaded();

  const recaptcha_token = await executeRecaptcha('login');

  Axios.post('/contact-sales', {
    firstName: firstName.value,
    lastName: lastName.value,
    phone: phone.value,
    email: email.value,
    company: company.value,
    audienceSize: audienceSize.value,
    recaptcha_token: recaptcha_token
  })
    .then((res) => {
      console.log(res);
      isLoading['submit'] = false;
      isLoading['success'] = true;
    })
    .catch((err) => {
      console.log(err);
      isLoading['submit'] = false;
      isLoading['error'] = true;
    });
};

onMounted(() => {
  isLoading['success'] = false;
  isLoading['error'] = false;
});
</script>

<style>
.grecaptcha-badge {
  visibility: hidden;
}
.contact-sales-animation-enter-active,
.contact-sales-animation-leave-active {
  transition: opacity 0.7s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}

.contact-sales-animation-enter-from,
.contact-sales-animation-leave-to {
  opacity: 0;
}

.contact-sales-animation-inner-enter-active {
  transition: all 0.7s cubic-bezier(0.52, 0.02, 0.19, 1.02) 0.15s;
}

.contact-sales-animation-inner-leave-active {
  transition: all 0.7s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}

.contact-sales-animation-inner-enter-from {
  opacity: 0;
  transform: scale (0.8);
}
.contact-sales-animation-inner-leave-to {
  transform: scale (0.8);
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .contact-sales-animation-enter-active {
    animation: moveDown 0.4s ease-in;
  }
  @keyframes moveDown {
    0% {
      transform: translateY(-120%);
    }

    100% {
      transform: translateY(0);
    }
  }
}

/* .grabber {
background-image: url(../media/images/mail-grabber-stunner-bg.svg);
position: contain;
left: 0;
background-repeat: no-repeat;
} */
</style>
